import React from "react"

import { AlternativeLoginForKeycode } from "./AlternativeLogin"
import { LoginWithKeycodeForm } from "./Form"

export const LoginWithKeycodeScreenContent = () => <>
  <LoginWithKeycodeForm/>
  <AlternativeLoginForKeycode/>
</>
